import AxiosFactory from '@/entities/security/AxiosFactory'
import {
  PAYMENT_METHODS_URL,
  PAYMENT_METHODS_GET_URL,
  PAYMENT_INTENT_TOKEN,
} from '@/featureModules/cardModule/endpoints'
import ApiErrorFactory from '@/entities/errors/api_errors/ApiErrorsFactory'
import { PaymentIntentPayloadI, PaymentMethodPayloadI } from '@/featureModules/cardModule/types/api/CreditCard'

export default class CardModuleApi {
  async postPaymentMethod(payment: PaymentMethodPayloadI) {
    try {
      const response = await AxiosFactory.createAxiosInstance().post(PAYMENT_METHODS_URL, payment)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
  async postPaymentMethodId(pmId: string) {
    try {
      const response = await AxiosFactory.createAxiosInstance().post(PAYMENT_METHODS_GET_URL, {
        payment_method_id: pmId,
      })
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
  async postPaymentIntent(paymentIntent: PaymentIntentPayloadI) {
    try {
      const response = await AxiosFactory.createAxiosInstance().post(PAYMENT_INTENT_TOKEN, paymentIntent)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
  async getPaymentMethods() {
    try {
      const response = await AxiosFactory.createAxiosInstance().get(PAYMENT_METHODS_URL)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
}
